module.exports = __webpack_public_path__ + "img/slash.54702860.svg";